import accounting from 'accounting';

const OFFER_PRICE = 'input#offer_price';
const OFFER_SHIPPING_PRICE = 'input#offer_shipping_price';
const OFFER_QUANTITY = '[data-quantity]';
const OFFER_TOTAL = 'input#offer_total';
const DEFAULT_QUANTITY = 1;
const DECIMAL = I18n.t('number.currency.format.separator');
const THOUSAND = I18n.t('number.currency.format.delimiter');
const JAPANESE_YEN = 'JPY';

class ReverbOffers {
  static selectDefaultOfferTab() {
    const buyerCount = $('#buying [data-offer-view-offer-container] > *').length;
    const sellerCount = $('#selling [data-offer-view-offer-container] > *').length;
    if (sellerCount > buyerCount) {
      window.Tabs.switchTab('selling');
    }
  }

  static moneyFormat() {
    let precision = 2;
    if ($(`[data-user-display-currency="${JAPANESE_YEN}"]`).length > 0) {
      precision = 0;
    }
    return {
      precision,
      symbol: '',
      decimal: DECIMAL,
      thousand: THOUSAND,
    };
  }

  static formatMoney(unformattedValue) {
    return accounting.formatMoney(unformattedValue, this.moneyFormat());
  }

  static formatMoneyFields(scope) {
    const price = scope.find(OFFER_PRICE);
    const shipping = scope.find(OFFER_SHIPPING_PRICE);
    const total = scope.find(OFFER_TOTAL);
    const unformattedPrice = accounting.unformat(price.val(), DECIMAL);
    const unformattedShipping = accounting.unformat(shipping.val(), DECIMAL);
    const unformattedTotal = (unformattedPrice * ReverbOffers.quantityValue(scope)) + unformattedShipping;

    shipping.val(this.formatMoney(unformattedShipping));
    total.val(this.formatMoney(unformattedTotal));
  }

  static formatFieldsOnLoad(scope) {
    const shipping = scope.find(OFFER_SHIPPING_PRICE);
    const total = scope.find(OFFER_TOTAL);

    const unformattedShipping = accounting.unformat(shipping.val(), DECIMAL);
    const formattedShipping = this.formatMoney(unformattedShipping);

    shipping.val(formattedShipping);
    total.val(formattedShipping);
  }

  static quantityValue(scope) {
    const offerQuantity = scope.find(OFFER_QUANTITY);

    // the seller side has a select tag with a value
    if (offerQuantity.val()) {
      return offerQuantity.val();
    }

    // on the buyer side there is a div with a data attribute 'quantity'
    if (offerQuantity.data('quantity')) {
      return offerQuantity.data('quantity');
    }

    // if there is no quantity specified, default to 1
    return DEFAULT_QUANTITY;
  }

  static calculateCounterOfferTotal(scope) {
    const price = scope.find(OFFER_PRICE);
    const shipping = scope.find(OFFER_SHIPPING_PRICE);
    const total = scope.find(OFFER_TOTAL);

    const unformattedPrice = accounting.unformat(price.val(), DECIMAL);
    const unformattedShipping = accounting.unformat(shipping.val(), DECIMAL);
    const unformattedTotal = (unformattedPrice * ReverbOffers.quantityValue(scope)) + unformattedShipping;

    total.val(this.formatMoney(unformattedTotal));
  }

  static calculateTotalOnChange() {
    const fields = $([OFFER_QUANTITY, OFFER_PRICE, OFFER_SHIPPING_PRICE].join());
    fields.change((field) => {
      const context = $(field.target).parents('form');
      ReverbOffers.formatMoneyFields(context);
      ReverbOffers.calculateCounterOfferTotal(context);
    });
  }
}

function init() {
  ReverbOffers.selectDefaultOfferTab();
  $.each($('form.edit_offer[data-counter-offer="true"]'), (i, v) => {
    ReverbOffers.formatFieldsOnLoad($(v));
  });
  ReverbOffers.calculateTotalOnChange();
}

export default {
  init,
};
